import React from "react";

import { ConnectorLogo } from "../../atoms/ConnectorLogo";
import {
  Card,
  Subtitle,
  TextStack,
  Title,
  TitleRow,
} from "./KgCollapsedNodeHoverCard.styles";
import type { KgCollapsedNodeHoverCardProps } from "./KgCollapsedNodeHoverCard.types";

export const KgCollapsedNodeHoverCard: React.FC<KgCollapsedNodeHoverCardProps> = ({
  title,
  subtitle,
  logoUrl,
  logoName,
  className,
}) => (
  <Card className={className} data-testid="kg-collapsed-hover-card">
    <TextStack>
      <TitleRow>
        {logoUrl && logoName && (
          <ConnectorLogo src={logoUrl} name={logoName} size="kg" />
        )}
        <Title title={title}>{title}</Title>
      </TitleRow>
      {subtitle && <Subtitle title={subtitle}>{subtitle}</Subtitle>}
    </TextStack>
  </Card>
);

export default KgCollapsedNodeHoverCard;
